<template>
  <div class="container">
    <man-body v-if="sex == 1 && type == 1"
              :direction="direction"
              @clickPart="clickPart"></man-body>
    <man-child-body v-if="sex == 1 && type == 0"
                    :direction="direction"
                    @clickPart="clickPart"></man-child-body>
    <woman-body v-if="sex == 2 && type == 1"
                :direction="direction"
                @clickPart="clickPart"></woman-body>
    <woman-child-body v-if="sex == 2 && type == 0"
                      :direction="direction"
                      @clickPart="clickPart"></woman-child-body>
    <div class="group sex">
      <div :class="sex == 1 ? 'item active' : 'item'"
           @click="changeSex(1)">男</div>
      <div :class="sex == 2 ? 'item active' : 'item'"
           @click="changeSex(2)">女</div>
    </div>
    <div class="group stage">
      <div :class="type == 1 ? 'item active' : 'item'"
           @click="changeType(1)">成人</div>
      <div :class="type == 0 ? 'item active' : 'item'"
           @click="changeType(0)">儿童</div>
    </div>
    <div class="turn"
         @click="changeDirection">转身</div>
    <div class="point"
         :style="'display:' + point.display + ';left:' + point.x + 'px;top:' + point.y + 'px;'"></div>
  </div>
</template>

<script>
import ManBody from './ManBody'
import ManChildBody from './ManChildBody'
import WomanBody from './WomanBody'
import WomanChildBody from './WomanChildBody'

export default {
  name: 'BodyPart',
  props: {
    sex: {
      type: Number,
      default: 1
    },
    type: {
      type: Number,
      default: 1
    },
    direction: {
      type: Number,
      default: 0
    }
  },
  components: {
    ManBody,
    ManChildBody,
    WomanBody,
    WomanChildBody
  },
  data() {
    return {
      minX: null,
      maxX: null,
      point: {
        display: 'none',
        x: -10,
        y: -10
      }
    }
  },
  mounted() {
    var screenHeight = document.body.clientHeight
    var screenWidth = document.body.clientWidth
    if (screenHeight && screenWidth) {
      var modelWidth = screenHeight / 2 - 16
      this.minX = (screenWidth - modelWidth) / 2
      this.maxX = screenWidth - this.minX
    }
  },
  methods: {
    showClick(e) {
      this.point = {
        x: e.clientX - 5,
        y: e.clientY - 75
      }
      if (this.point.x > this.minX && this.point.x < this.maxX) {
        this.point.display = 'block'
      } else {
        this.point.display = 'none'
      }
    },
    changeSex(sex) {
      this.point.display = 'none'
      this.$emit('change', sex, 0)
    },
    changeType(type) {
      this.point.display = 'none'
      this.$emit('change', type, 1)
    },
    changeDirection() {
      this.point.display = 'none'
      this.$emit('change', 1 - this.direction, 2)
    },
    clickPart(e, id, name) {
      this.showClick(e)
      this.$emit('clickPart', id, name)
    }
  }
}
</script>

<style scoped>
.container {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: white;
}

.point {
  position: absolute;
  z-index: 9;
  width: 10px;
  height: 10px;
  background-color: red;
  border-radius: 5px;
  transform: scale(1);
  transition: all 0.3s;
}

.group {
  display: flex;
  flex-direction: row;
  align-items: center;
  background: whitesmoke;
  border-radius: 30px;
  padding: 1px;
  overflow: hidden;
}

.group .item {
  flex: 1;
  min-width: 40px;
  text-align: center;
  line-height: 22px;
  color: black;
  font-size: 12px;
  border-radius: 22px;
}

.group .item.active {
  color: white;
  background-color: #0063aa;
}

.sex {
  position: absolute;
  left: 10px;
  top: 10px;
}

.stage {
  position: absolute;
  right: 10px;
  top: 10px;
}

.turn {
  position: absolute;
  right: 20px;
  bottom: 20px;
  width: 40px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  font-size: 12px;
  color: white;
  border-radius: 40px;
  background-color: #0063aa;
}
</style>